import { useAuiState } from "@assistant-ui/react";

export const useIsMessageRunning = () =>
  useAuiState(s => s.message.status?.type === "running");

export const useMessageHasContent = () =>
  useAuiState(s => s.message.parts.length > 0);
